import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import Button from '@mui/material/Button';
import 'ag-grid-enterprise';
import * as Flags from 'country-flag-icons/react/3x2'
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";

import { useMediaQuery, useTheme } from '@mui/material';
const PriceGroupList = () => {


    const theme = useTheme();
     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [selectedRows, setSelectedRows] = useState([]);
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState("")
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const gridRef = useRef();
    const navigate = useNavigate();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'pgId', enableRowGroup: true, headerName: "Name" },
        { field: 'description', enableRowGroup: true }
    ]);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                await OAuthService.deleteData(url, row.pgId);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                loadData();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };


    const onGridReady = useCallback((params) => {
        setGridApi(params.api);
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'PriceGroups.xlsx',
            sheetName: 'Price Groups'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const loadData = async () => {
        gridApi?.showLoadingOverlay();
        try {
            const list = await OAuthService.getList(url + `?size=1000&sort=pgId,asc`);
            let pricegroup = list.data?._embedded?.priceGroups;
            setRowData(pricegroup);
        } catch (error) {
            setError(error.message);
        } finally {
    gridApi?.hideOverlay();
  }
    }

    useEffect(() => {
        if (gridApi) {
            loadData();
        }
    }, [gridApi]);

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

   
     const goToRoleEdit = useCallback(
          (data) => {
            if (data?.pgId!== undefined) {
              navigate("/editPriceGrops/" + data.pgId);
            }
          },
          [navigate],
        );
        const onRowDoubleClicked = (params) => {
          if (isMobile) return;
          goToRoleEdit(params?.data);
        };
    
        const onRowClicked = (params) => {
          if (!isMobile) return;
          goToRoleEdit(params?.data);
        };
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="PriceGroup"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                addPageLink="/addpricegroup"
                pageName="Price Group List"
                deleteDisable={deleteDisable}
                successMsg={successMsg}
                snackState={snackState}
                gridRef={gridRef}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={10}
                    cacheBlockSize={10}
                    saveGridStateName={'priceGroupList'}
                />
            </div>
        </>
    );
}

export default PriceGroupList